// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__pAWyk","header":"PatientBlock_header__39nk6","label":"PatientBlock_label__1qlym","option":"PatientBlock_option__3Oiqf"};